module.exports = __webpack_public_path__ + "img/frases-life-is-love-preview.f3f6d15c.jpg";